import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { GrupoTaricFrExService } from './grupotaricfrex.service';
import { GrupoTaricFrExViewModel } from './grupotaricfrex.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';

import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';

@Component({
    selector: 'app-grupotaricfrex-edit',
    templateUrl: './grupotaricfrex-edit.component.html',
})
export class GrupoTaricFrExEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle: string = 'Nuevo';
    grupotaricfrEx: GrupoTaricFrExViewModel;
    listGruposPaisesFr: Tc[];
    visibilitySpinner: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private grupoTaricFrExService: GrupoTaricFrExService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.grupotaricfrEx = new GrupoTaricFrExViewModel();
    }

    ngOnInit() {
        this.globalService.getGrupoPaisesFr().subscribe(res => {
            this.listGruposPaisesFr = res;
        });

        this.createForm();

        // Suscribirse a los cambios de IdGrupoPaisFr para revalidar CodigoTaric
        this.form.get('IdGrupoPaisFr')?.valueChanges.subscribe(() => {
            this.form.get('CodigoTaric')?.updateValueAndValidity();
        });

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.grupoTaricFrExService.getGrupoTaricFrEx(id).subscribe(result => {
                this.grupotaricfrEx = result;
                this.updateForm();
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            CodigoTaric: ['', Validators.compose([Validators.required, CustomValidator.CodigoTaricMin4])],
            IdGrupoPaisFr: [null, Validators.required],
            Porcentaje: [null, Validators.compose([Validators.required, Validators.maxLength(3), Validators.max(100)])],
            Activo: [true, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.grupotaricfrEx.Descripcion,
            CodigoTaric: this.grupotaricfrEx.CodigoTaric,
            IdGrupoPaisFr: this.grupotaricfrEx.IdGrupoPaisFr,
            Porcentaje: this.grupotaricfrEx.Porcentaje,
            Activo: this.grupotaricfrEx.Activo,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        this.visibilitySpinner = true;

        let grupotaricfrEx = new GrupoTaricFrExViewModel();

        grupotaricfrEx.Descripcion = this.form.value.Descripcion;
        grupotaricfrEx.CodigoTaric = this.form.value.CodigoTaric;
        grupotaricfrEx.IdGrupoPaisFr = this.form.value.IdGrupoPaisFr;
        grupotaricfrEx.Porcentaje = this.form.value.Porcentaje;
        grupotaricfrEx.Activo = this.form.value.Activo;

        grupotaricfrEx.Id = this.grupotaricfrEx.Id;

        if (this.editMode) {
            this.grupoTaricFrExService.editGrupoTaricFrEx(grupotaricfrEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Grupo Taric FR modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.grupoTaricFrExService.createGrupoTaricFrEx(grupotaricfrEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Grupo Taric FR añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/frecuenciareducida/grupostaricfrex']);
    }
}
